module.exports = __webpack_public_path__ + "img/redchirp-logo-square-center.d4985182.png";